import React, { FC } from 'react';
import styles from './Header.scss';
import { HeaderLogo } from './HeaderLogo';
import { HeaderProgress } from './HeaderProgress';

export const Header: FC = () => {
  return (
    <div className={styles.header}>
      <HeaderLogo />
      <HeaderProgress />
    </div>
  );
};
